/*
 * @Description: 工具方法
 * @Version: 1.0
 * @Author: wangmingxu@kuaishou.com
 * @Date: 2022-02-25 15:53:18
 * @LastEditors: wangmingxu@kuaishou.com
 * @LastEditTime: 2022-02-28 20:19:20
 */
var throttle = function throttle(fn, wait) {
  var timer = null;
  return function () {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        timer = null;
      }, wait);
    }
  };
};
/**
 * 获取number的小数位数
 * @param num 数字
 * @returns
 */
function getDecimalCount(num) {
  var str = "".concat(num).split('.')[1];
  /* istanbul ignore next */
  return str ? str.length : 0;
}
/**
 * 数字相加，可以用于消除精度丢失问题（相减可用加负数实现，如:add(a, -b)）
 * @param num1 加数1
 * @param num2 加数2
 * @returns 和数
 */
function addPrecisely(num1, num2) {
  var l1 = getDecimalCount(num1);
  var l2 = getDecimalCount(num2);
  var m = Math.pow(10, Math.max(l1, l2));
  return (num1 * m + num2 * m) / m;
}
/**
 * 是否是浏览器环境
 */
var isClient = typeof window !== 'undefined';
/**
 * 16进制转换成rgb数值
 * @param {String} val  #ffffff 或者 #fff
 * @return {String}    255，255，255
 */
function rgbTransform(color) {
  if (!/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(color)) {
    console.warn('please provide a effective color value for sharp components'); // eslint-disable-line
    return '';
  }
  var r;
  var g;
  var b;
  if (color.length === 4) {
    r = parseInt(color.slice(1, 2), 16);
    g = parseInt(color.slice(2, 3), 16);
    b = parseInt(color.slice(3), 16);
  }
  if (color.length === 7) {
    r = parseInt(color.slice(1, 3), 16);
    g = parseInt(color.slice(3, 5), 16);
    b = parseInt(color.slice(5), 16);
  }
  return "".concat(r, ", ").concat(g, ", ").concat(b);
}

export { addPrecisely, isClient, rgbTransform, throttle };
